import { render } from "./Project.vue?vue&type=template&id=aaeea40c&scoped=true&ts=true"
import script from "./Project.ts?vue&type=script&lang=ts"
export * from "./Project.ts?vue&type=script&lang=ts"

import "./Project.scss?vue&type=style&index=0&id=aaeea40c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aaeea40c"]])

export default __exports__